// extracted by mini-css-extract-plugin
export default {"innerWrapper":"CB-z","tooltipWrapper":"DB-z","icon":"EB-z","tooltip":"FB-z","content":"GB-z"};